import type { FragmentOf, ResultOf } from "@opensea/graphql"
import { readFragment } from "@opensea/graphql"
import { getItemQuoteResultErrorFragment } from "./getItemQuoteResultError.fragment"

export class ItemQuoteNotFound extends Error {
  protected item: ResultOf<typeof getItemQuoteResultErrorFragment>["item"]
  public constructor(
    item: ResultOf<typeof getItemQuoteResultErrorFragment>["item"],
  ) {
    super("Unavailable")
    this.item = item
  }
}

export const getItemQuoteResultError = (
  itemQuoteResultKey: FragmentOf<typeof getItemQuoteResultErrorFragment>,
) => {
  const itemQuoteResult = readFragment(
    getItemQuoteResultErrorFragment,
    itemQuoteResultKey,
  )
  switch (itemQuoteResult.__typename) {
    case "ItemQuoteNotFound":
      return new ItemQuoteNotFound(itemQuoteResult.item)
  }
}
